import { Component } from "@angular/core";
import { ConfirmationService } from "primeng/api";
import { Router, ActivatedRoute } from "@angular/router";
import { PARAM_TECHNOLOGY_PATH } from "src/app/admin/constants/constants";

import { AbstractListController } from "src/app/admin/common/abstract-list.component";
import { TechnologyService } from "src/app/services/technology.service";
import { Technology } from "src/app/models/technology";
import { CommonModule } from "@angular/common";
import { DataTableComponent } from "src/app/admin/common/data-table/data-table.component";
import {
  TableColumn,
  TableFilter,
} from "src/app/admin/common/data-table/data-table.model";

@Component({
  standalone: true,
  selector: "app-manage-technology",
  templateUrl: "./manage-technology.component.html",
  imports: [CommonModule, DataTableComponent],
})
export class ManageTechnologyComponent extends AbstractListController<
  Technology,
  any
> {
  title = "Technology";

  tableColumns: TableColumn[] = [
    { field: "id", header: "ID", width: "80px" },
    { field: "title", header: "Nome" },
    { field: "description", header: "Descrizione" },
  ];

  tableFilters: TableFilter[] = [
    { field: "id", header: "ID", type: "string" },
    { field: "title", header: "Nome", type: "string" },
    { field: "description", header: "Descrizione", type: "string" },
  ];

  editLink = (row: Technology): any[] => [
    "/admin/settings/technology/edit",
    row.id,
  ];

  constructor(
    private technologyService: TechnologyService,
    protected confirmationService: ConfirmationService,
    router: Router,
    route: ActivatedRoute,
  ) {
    super(
      technologyService,
      confirmationService,
      router,
      route,
      PARAM_TECHNOLOGY_PATH,
    );
    this.useTableFilters = true;
  }
}
